import { AorCancellationStatus } from '@zorro/clients';
import { Select, type SelectProps } from '@zorro/design-system/v2/Select';
import { aorCancellationStatusLabelConfig } from '@zorro/types';
import { FormErrorMessage } from '@zorro/web/design-system';
import {
  FieldPath,
  FieldValues,
  UseControllerProps,
  useController,
} from 'react-hook-form';

const AOR_CANCELLATION_STATUS_SELECT_OPTIONS = Object.values(
  AorCancellationStatus
)
  .filter((option) => option !== AorCancellationStatus.NOT_APPLICABLE)
  .map((option) => ({
    value: String(option),
    label: aorCancellationStatusLabelConfig[option],
  }));

type Props<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = UseControllerProps<TFieldValues, TName> & {
  selectProps?: SelectProps;
};

export const ChangeAorCancellationStatusInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  selectProps,
  ...formField
}: Props<TFieldValues, TName>) => {
  const {
    field,
    formState: { errors },
  } = useController(formField);

  return (
    <>
      <Select
        {...field}
        label="AOR cancellation status"
        placeholder="Select AOR cancellation status"
        data={AOR_CANCELLATION_STATUS_SELECT_OPTIONS}
        {...selectProps}
      />

      <FormErrorMessage fieldName={formField.name} errors={errors} />
    </>
  );
};
